import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import api from '../lib/api';
import SEO from '../components/SEO';

export default function News() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/articles').then(r => { setArticles(r.data); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  return (
    <div data-testid="news-page">
      <SEO
        title="Hírek és aktualitások"
        description="Kövesse nyomon a legfontosabb pénzügyi híreket, adó- és számviteli változásokat az AGM Consulting blogján."
      />
      <section className="py-20 sm:py-28 bg-[#0B1B3D]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <span className="text-[#C5A059] text-xs uppercase tracking-[0.2em] font-semibold">Blog</span>
          <h1 className="mt-4 text-4xl sm:text-5xl lg:text-6xl font-['Outfit'] font-light text-white tracking-tight">
            Hírek és <span className="font-semibold">aktualitások</span>
          </h1>
          <p className="mt-6 text-lg text-[#94A3B8] max-w-2xl">
            Kövesse nyomon a legfontosabb pénzügyi híreket, adó- és számviteli változásokat.
          </p>
        </div>
      </section>

      <section className="py-16 sm:py-24 bg-[#FAFAFA]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {loading ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {[1, 2, 3].map(i => (
                <div key={i} className="bg-white rounded-lg border border-[#E2E8F0] p-6 animate-pulse">
                  <div className="h-40 bg-[#E2E8F0] rounded-lg mb-4" />
                  <div className="h-4 bg-[#E2E8F0] rounded w-1/3 mb-3" />
                  <div className="h-6 bg-[#E2E8F0] rounded mb-2" />
                  <div className="h-4 bg-[#E2E8F0] rounded w-2/3" />
                </div>
              ))}
            </div>
          ) : articles.length === 0 ? (
            <div className="text-center py-20">
              <p className="text-[#64748B] text-lg">Még nincsenek publikált cikkek.</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {articles.map((article) => (
                <Link
                  key={article.id}
                  to={`/hirek/${article.slug}`}
                  data-testid={`article-card-${article.slug}`}
                  className="group bg-white border border-[#E2E8F0] rounded-lg overflow-hidden hover:-translate-y-1 hover:shadow-lg transition-all duration-300"
                >
                  {article.featured_image ? (
                    <div className="aspect-video overflow-hidden bg-[#E2E8F0]">
                      <img
                        src={article.featured_image.startsWith('/api') ? `${process.env.REACT_APP_BACKEND_URL}${article.featured_image}` : article.featured_image}
                        alt={article.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      />
                    </div>
                  ) : (
                    <div className="aspect-video bg-[#0B1B3D]/5 flex items-center justify-center">
                      <span className="text-[#64748B] text-sm">AGM Consulting</span>
                    </div>
                  )}
                  <div className="p-6">
                    <span className="text-xs text-[#64748B]">
                      {new Date(article.created_at).toLocaleDateString('hu-HU', { year: 'numeric', month: 'long', day: 'numeric' })}
                    </span>
                    <h2 className="mt-2 text-lg font-['Outfit'] font-semibold text-[#0B1B3D] group-hover:text-[#C5A059] transition-colors line-clamp-2">
                      {article.title}
                    </h2>
                    <p className="mt-2 text-sm text-[#64748B] line-clamp-3">{article.excerpt}</p>
                    <span className="inline-flex items-center gap-1 mt-4 text-sm font-medium text-[#0B1B3D] group-hover:text-[#C5A059] transition-colors">
                      Tovább olvasom <ArrowRight size={14} />
                    </span>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
